module.exports = __webpack_public_path__ + "static/Gotham-Bold-8192b4e7bf534a005eb74c30bbd0aa8d.woff2";